import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'
import { AuthorizeSetting } from '../types'

type AuthorizeSettingInput = {
  name: string
  apiGateway: string
  apiLoginId: string
  transactionKey: string
  clientKey?: string
  signatureKey?: string
}

export type CreateAuthorizeSettingAction = FSA<undefined, AuthorizeSetting, string>
type CreateAuthorizeSetting = (authorizeSettingData: AuthorizeSettingInput) => MrxThunk<CreateAuthorizeSettingAction, Promise<boolean>>
type QueryResponse = GraphQLResponse<'createAuthorizeSetting', AuthorizeSetting>

const CREATE_AUTHORIZE_SETTING = `
  mutation createAuthorizeSetting ($workspaceId: Int!, $authorizeSettingData: AuthorizeSettingInput!) {
    createAuthorizeSetting (workspaceId: $workspaceId, authorizeSettingData: $authorizeSettingData) {
      id
      name
      apiGateway
      apiLoginId
      transactionKey
      clientKey
      signatureKey
      createdAt
      updatedAt
    }
  }
`

const createAuthorizeSetting: CreateAuthorizeSetting = (authorizeSettingData) => async (dispatch, getState) => {
  let isSaved = false

  dispatch({
    type: t.CREATE_AUTHORIZE_SETTING,
    meta: { done: false }
  })

  try {
    const workspaceId = getState()?.workspaces?.activeWorkspace?.id

    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: CREATE_AUTHORIZE_SETTING,
      variables: { workspaceId, authorizeSettingData }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { createAuthorizeSetting } = data
    if (!createAuthorizeSetting) {
      throw new Error("Can't create Authorize Setting!")
    }

    dispatch({
      type: t.CREATE_AUTHORIZE_SETTING,
      payload: createAuthorizeSetting,
      meta: { done: true }
    })
    isSaved = true
  } catch (err) {
    dispatch({
      type: t.CREATE_AUTHORIZE_SETTING,
      payload: extractErrorInfo(err) as string,
      error: true
    })
  }

  return isSaved
}

export { createAuthorizeSetting }
